export const FCM_UPDATE_TYPES = {
  MESSAGES_USER: 'messages_user',
  TICKET: 'ticket',
  USER_AUTHS: 'user_auths',
  DELETE_TICKET: 'delete_ticket',
  DELETE_AUTH: 'delete_auth',
  DELETE_BOTH: 'delete_both',
}

export const FCM_ACTIONS = {
  NEW: 'new',
  DELETE: 'delete',
  REFRESH: 'refresh',
  UPDATE: 'update',
}

export const BROADCAST_UPDATE_TYPES = {
  TICKET: 'ticket',
  DELETE_TICKET: 'delete_ticket',
  APPROVAL: 'approval',
  DELETE_AUTH: 'delete_auth',
  MESSAGE: 'message',
  ACCOUNT_DATA: 'account_data',
  COMPANIES_DIRECTORY: 'companies_directory',
  QUERY_DATA: 'query_data',
  SETTINGS_UPDATE: 'settings_update',
}

export const APP_NAME = 'aigov'

export const FCM_BANNER_STATES = {
  NOT_SUPPORTED: 'NOT_SUPPORTED',
  BROWSER_BLOCKED: 'BROWSER_BLOCKED',
  OS_BLOCKED: 'OS_BLOCKED',
  INIT_ERROR: 'INIT_ERROR',
  UNAVAILABLE: 'UNAVAILABLE',
}

export const FCM_BANNER_TITLES = {
  [FCM_BANNER_STATES.NOT_SUPPORTED]: 'Browser not supported',
  [FCM_BANNER_STATES.BROWSER_BLOCKED]: 'Notifications blocked in browser',
  [FCM_BANNER_STATES.OS_BLOCKED]: 'Notifications blocked by Windows',
  [FCM_BANNER_STATES.INIT_ERROR]: 'Notifications unavailable',
  [FCM_BANNER_STATES.UNAVAILABLE]: 'Notifications unavailable',
}

export const FCM_BANNER_MESSAGES = {
  [FCM_BANNER_STATES.NOT_SUPPORTED]:
    'Your browser does not support real-time notifications. Try Chrome, Firefox, or Edge for live updates.',
  [FCM_BANNER_STATES.BROWSER_BLOCKED]:
    'Click the lock icon in your browser address bar → Change Notifications from "Block" to "Allow" → Refresh the page.',
  [FCM_BANNER_STATES.OS_BLOCKED]:
    'Open Windows Settings → System → Notifications → Ensure your browser is turned ON → Refresh the page.',
  [FCM_BANNER_STATES.INIT_ERROR]: 'Something went wrong. Please refresh the page and try again.',
  [FCM_BANNER_STATES.UNAVAILABLE]:
    'Without notifications enabled, you will not receive real-time updates.',
}

export const FCM_ERROR_TYPES = {
  HANDLER_ERROR: 'FCM Handler Error',
  PARSE_ERROR: 'FCM Parse Error',
}

export const FCM_HANDLERS = {
  REFRESH_TICKET: 'handleRefreshTicket',
  DELETE_TICKET: 'handleDeleteTicket',
  DELETE_BOTH: 'handleDeleteBoth',
  NEW_APPROVAL: 'handleNewApproval',
  REFRESH_APPROVAL: 'handleRefreshApproval',
  DELETE_APPROVAL: 'handleDeleteApproval',
}

export const FCM_PENDING_PREFIXES = {
  TICKET: 'ticket',
  APPROVAL: 'approval',
  DELETE_TICKET: 'delete_ticket',
  DELETE_AUTH: 'delete_auth',
}

export const FCM_MESSAGE_TYPES = {
  BACKGROUND: 'FCM_BACKGROUND_MESSAGE',
}

export const FCM_AUTO_REFRESH_MS = 5000
